// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar-container {
  margin: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
}
.calendar-comp::placeholder {
  color: #757575;
}
.calendar-icon-image {
  cursor: pointer;
}
:where(.css-dev-only-do-not-override-7ny38l).ant-picker-dropdown
  .ant-picker-cell-in-view.ant-picker-cell-range-start:not(
    .ant-picker-cell-disabled
  )
  .ant-picker-cell-inner,
:where(.css-dev-only-do-not-override-49qm).ant-picker-dropdown
  .ant-picker-cell-in-view.ant-picker-cell-range-end:not(
    .ant-picker-cell-disabled
  )
  .ant-picker-cell-inner {
  color: #fff;
  background: #d2042d !important;
  margin: 0px 5px 0px 5px !important;
}
:where(.css-dev-only-do-not-override-7ny38l).ant-picker-dropdown
  .ant-picker-cell-in-view.ant-picker-cell-in-range:not(
    .ant-picker-cell-disabled
  ):before {
  margin: 0px 5px 0px 5px !important;
  border-radius: 5px !important;
  color: #fff;
}
:where(.css-dev-only-do-not-override-7ny38l).ant-picker-dropdown
  .ant-picker-cell-in-view.ant-picker-cell-range-end:not(
    .ant-picker-cell-disabled
  )
  .ant-picker-cell-inner {
  color: #fff !important;
  background: #d2042d !important;
  margin: 0px 4px 0px 4px !important;
}
.range-picker-common
  .ant-picker-dropdown
  .ant-picker-cell-in-view.ant-picker-cell-today
  .ant-picker-cell-inner::before {
  position: absolute;
  top: 0;
  inset-inline-end: 0;
  bottom: 0;
  inset-inline-start: 0;
  z-index: 1;
  border: 1px solid #d2042d !important;
  border-radius: 4px;
  content: "";
}
:where(.css-dev-only-do-not-override-7ny38l).ant-picker-dropdown
  .ant-picker-cell-in-view.ant-picker-cell-in-range:not(
    .ant-picker-cell-disabled
  ):before {
  background: #d2042d;
}

.range-picker-common
  .ant-picker-dropdown
  .ant-picker-cell-in-view.ant-picker-cell-today
  .ant-picker-cell-inner::before {
  position: absolute;
  top: 0;
  inset-inline-end: 0;
  bottom: 0;
  inset-inline-start: 0;
  z-index: 1;
  border: 1px solid #d2042d;
  border-radius: 4px;
  content: "";
}
.ant-picker-dropdown
  .ant-picker-cell-in-view.ant-picker-cell-range-end:not(
    .ant-picker-cell-disabled
  )
  .ant-picker-cell-inner {
  color: #fff;
  background: #d2042d;
}

.ant-picker-dropdown
  .ant-picker-cell-in-view.ant-picker-cell-selected:not(
    .ant-picker-cell-disabled
  )
  .ant-picker-cell-inner,
.ant-picker-dropdown
  .ant-picker-cell-in-view.ant-picker-cell-range-start:not(
    .ant-picker-cell-disabled
  )
  .ant-picker-cell-inner,
.ant-picker-dropdown
  .ant-picker-cell-in-view.ant-picker-cell-range-end:not(
    .ant-picker-cell-disabled
  )
  .ant-picker-cell-inner {
  color: #fff;
  background: #d2042d;
}
.ant-picker-range-arrow {
  display: none !important;
}
.ant-picker-content th {
  font-family: Roboto !important;
  font-size: 14px !important;
  font-weight: 500 !important;
}
.ant-picker-content td {
  font-family: "Montserrat" !important;
  font-size: 14px !important;
  font-weight: 500 !important;
}
.ant-picker-header-view
  .ant-picker-header-month-select
  .ant-picker-header-month {
  font-family: "Montserrat" !important;
  font-size: 16px !important;
  font-weight: 500 !important;
}
.ant-picker-header-view {
  font-family: "Montserrat" !important;
  font-size: 16px !important;
  font-weight: 500 !important;
}
.ant-picker-input {
  font-family: "Montserrat" !important;
  font-size: 8px !important;
  font-weight: 500 !important;
  cursor: pointer;
}
.range-picker-common
  .ant-picker-dropdown
  .ant-picker-cell-in-view.ant-picker-cell-selected:not(
    .ant-picker-cell-disabled
  )
  .ant-picker-cell-inner,
:where(.css-dev-only-do-not-override-1a3rktk).ant-picker-dropdown
  .ant-picker-cell-in-view.ant-picker-cell-range-start:not(
    .ant-picker-cell-disabled
  )
  .ant-picker-cell-inner,
:where(.css-dev-only-do-not-override-1a3rktk).ant-picker-dropdown
  .ant-picker-cell-in-view.ant-picker-cell-range-end:not(
    .ant-picker-cell-disabled
  )
  .ant-picker-cell-inner {
  color: #fff;
  background: #d2042d;
}
.range-picker-common
  .ant-picker-dropdown
  .ant-picker-cell-in-view.ant-picker-cell-in-range:not(
    .ant-picker-cell-disabled
  ):before {
  color: #fff;
  background-color: #f1b1be;
}
.ant-picker-calendar .highlighted-date {
  background: #ff4d4f;
  color: #fff;
  border-radius: 50%;
  display: inline-block;
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
}

.ant-picker-calendar .custom-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.custom-header span {
  font-size: 16px;
  font-weight: bold;
}

.custom-header button {
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
}

.custom-header button:hover {
  color: #1890ff;
}
:where(.css-dev-only-do-not-override-xepvsj).ant-picker-dropdown
  .ant-picker-cell-in-view.ant-picker-cell-today
  .ant-picker-cell-inner::before {
  position: absolute;
  top: 0;
  inset-inline-end: 0;
  bottom: 0;
  inset-inline-start: 0;
  z-index: 1;
  border: 1px solid #d2042d !important;
  border-radius: 4px;
  content: "";
}

@media (max-width: 1024px) {
  .calendar-container {
    width: 250px;
    margin: auto;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 16px;
  }
}
@media (min-width: 321px) and (max-width: 375px) {
  .calendar-container {
    width: 200px;
    margin: auto;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 16px;
  }
}
@media screen and (min-width: 768px) {
  .ant-picker-input {
    font-size: 15px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/calendar/CalendarComponent.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;;;;;;;;;;EAUE,WAAW;EACX,8BAA8B;EAC9B,kCAAkC;AACpC;AACA;;;;EAIE,kCAAkC;EAClC,6BAA6B;EAC7B,WAAW;AACb;AACA;;;;;EAKE,sBAAsB;EACtB,8BAA8B;EAC9B,kCAAkC;AACpC;AACA;;;;EAIE,kBAAkB;EAClB,MAAM;EACN,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,UAAU;EACV,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;AACb;AACA;;;;EAIE,mBAAmB;AACrB;;AAEA;;;;EAIE,kBAAkB;EAClB,MAAM;EACN,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;AACA;;;;;EAKE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;;EAeE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;;;EAGE,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;EAC3B,eAAe;AACjB;AACA;;;;;;;;;;;;;;;;EAgBE,WAAW;EACX,mBAAmB;AACrB;AACA;;;;;EAKE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;AACA;;;EAGE,kBAAkB;EAClB,MAAM;EACN,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,UAAU;EACV,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE;IACE,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;EACf;AACF;AACA;EACE;IACE,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;EACf;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".calendar-container {\n  margin: auto;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 16px;\n}\n.calendar-comp::placeholder {\n  color: #757575;\n}\n.calendar-icon-image {\n  cursor: pointer;\n}\n:where(.css-dev-only-do-not-override-7ny38l).ant-picker-dropdown\n  .ant-picker-cell-in-view.ant-picker-cell-range-start:not(\n    .ant-picker-cell-disabled\n  )\n  .ant-picker-cell-inner,\n:where(.css-dev-only-do-not-override-49qm).ant-picker-dropdown\n  .ant-picker-cell-in-view.ant-picker-cell-range-end:not(\n    .ant-picker-cell-disabled\n  )\n  .ant-picker-cell-inner {\n  color: #fff;\n  background: #d2042d !important;\n  margin: 0px 5px 0px 5px !important;\n}\n:where(.css-dev-only-do-not-override-7ny38l).ant-picker-dropdown\n  .ant-picker-cell-in-view.ant-picker-cell-in-range:not(\n    .ant-picker-cell-disabled\n  ):before {\n  margin: 0px 5px 0px 5px !important;\n  border-radius: 5px !important;\n  color: #fff;\n}\n:where(.css-dev-only-do-not-override-7ny38l).ant-picker-dropdown\n  .ant-picker-cell-in-view.ant-picker-cell-range-end:not(\n    .ant-picker-cell-disabled\n  )\n  .ant-picker-cell-inner {\n  color: #fff !important;\n  background: #d2042d !important;\n  margin: 0px 4px 0px 4px !important;\n}\n.range-picker-common\n  .ant-picker-dropdown\n  .ant-picker-cell-in-view.ant-picker-cell-today\n  .ant-picker-cell-inner::before {\n  position: absolute;\n  top: 0;\n  inset-inline-end: 0;\n  bottom: 0;\n  inset-inline-start: 0;\n  z-index: 1;\n  border: 1px solid #d2042d !important;\n  border-radius: 4px;\n  content: \"\";\n}\n:where(.css-dev-only-do-not-override-7ny38l).ant-picker-dropdown\n  .ant-picker-cell-in-view.ant-picker-cell-in-range:not(\n    .ant-picker-cell-disabled\n  ):before {\n  background: #d2042d;\n}\n\n.range-picker-common\n  .ant-picker-dropdown\n  .ant-picker-cell-in-view.ant-picker-cell-today\n  .ant-picker-cell-inner::before {\n  position: absolute;\n  top: 0;\n  inset-inline-end: 0;\n  bottom: 0;\n  inset-inline-start: 0;\n  z-index: 1;\n  border: 1px solid #d2042d;\n  border-radius: 4px;\n  content: \"\";\n}\n.ant-picker-dropdown\n  .ant-picker-cell-in-view.ant-picker-cell-range-end:not(\n    .ant-picker-cell-disabled\n  )\n  .ant-picker-cell-inner {\n  color: #fff;\n  background: #d2042d;\n}\n\n.ant-picker-dropdown\n  .ant-picker-cell-in-view.ant-picker-cell-selected:not(\n    .ant-picker-cell-disabled\n  )\n  .ant-picker-cell-inner,\n.ant-picker-dropdown\n  .ant-picker-cell-in-view.ant-picker-cell-range-start:not(\n    .ant-picker-cell-disabled\n  )\n  .ant-picker-cell-inner,\n.ant-picker-dropdown\n  .ant-picker-cell-in-view.ant-picker-cell-range-end:not(\n    .ant-picker-cell-disabled\n  )\n  .ant-picker-cell-inner {\n  color: #fff;\n  background: #d2042d;\n}\n.ant-picker-range-arrow {\n  display: none !important;\n}\n.ant-picker-content th {\n  font-family: Roboto !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n}\n.ant-picker-content td {\n  font-family: \"Montserrat\" !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n}\n.ant-picker-header-view\n  .ant-picker-header-month-select\n  .ant-picker-header-month {\n  font-family: \"Montserrat\" !important;\n  font-size: 16px !important;\n  font-weight: 500 !important;\n}\n.ant-picker-header-view {\n  font-family: \"Montserrat\" !important;\n  font-size: 16px !important;\n  font-weight: 500 !important;\n}\n.ant-picker-input {\n  font-family: \"Montserrat\" !important;\n  font-size: 8px !important;\n  font-weight: 500 !important;\n  cursor: pointer;\n}\n.range-picker-common\n  .ant-picker-dropdown\n  .ant-picker-cell-in-view.ant-picker-cell-selected:not(\n    .ant-picker-cell-disabled\n  )\n  .ant-picker-cell-inner,\n:where(.css-dev-only-do-not-override-1a3rktk).ant-picker-dropdown\n  .ant-picker-cell-in-view.ant-picker-cell-range-start:not(\n    .ant-picker-cell-disabled\n  )\n  .ant-picker-cell-inner,\n:where(.css-dev-only-do-not-override-1a3rktk).ant-picker-dropdown\n  .ant-picker-cell-in-view.ant-picker-cell-range-end:not(\n    .ant-picker-cell-disabled\n  )\n  .ant-picker-cell-inner {\n  color: #fff;\n  background: #d2042d;\n}\n.range-picker-common\n  .ant-picker-dropdown\n  .ant-picker-cell-in-view.ant-picker-cell-in-range:not(\n    .ant-picker-cell-disabled\n  ):before {\n  color: #fff;\n  background-color: #f1b1be;\n}\n.ant-picker-calendar .highlighted-date {\n  background: #ff4d4f;\n  color: #fff;\n  border-radius: 50%;\n  display: inline-block;\n  width: 28px;\n  height: 28px;\n  line-height: 28px;\n  text-align: center;\n}\n\n.ant-picker-calendar .custom-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.custom-header span {\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.custom-header button {\n  background: none;\n  border: none;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.custom-header button:hover {\n  color: #1890ff;\n}\n:where(.css-dev-only-do-not-override-xepvsj).ant-picker-dropdown\n  .ant-picker-cell-in-view.ant-picker-cell-today\n  .ant-picker-cell-inner::before {\n  position: absolute;\n  top: 0;\n  inset-inline-end: 0;\n  bottom: 0;\n  inset-inline-start: 0;\n  z-index: 1;\n  border: 1px solid #d2042d !important;\n  border-radius: 4px;\n  content: \"\";\n}\n\n@media (max-width: 1024px) {\n  .calendar-container {\n    width: 250px;\n    margin: auto;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    padding: 16px;\n  }\n}\n@media (min-width: 321px) and (max-width: 375px) {\n  .calendar-container {\n    width: 200px;\n    margin: auto;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    padding: 16px;\n  }\n}\n@media screen and (min-width: 768px) {\n  .ant-picker-input {\n    font-size: 15px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
